export const Translate = {
    messages: {
        noResponseMixtureScreen: "You are not connected to your RealTime Audio device. Please double check your device id and try entering it again.",
        webJamNotConnected: "You are not connected to your Webjam device. Please double check your device id and try entering it again.",
        webJamConnected: "You are now connected with a RealTime Audio device and are free to jam in real-time. Please note: The AI technology embedded in this system learns over time. Please allow it five minutes as it further optimizes the connection between participants. This process will restart automatically in the background after each new participant arrives. To view your current latency metrics and to make manual adjustments, click the cog on the mixer menu to access your audio settings menu.",
        disConnected: "You are disconnected.",
        autoMakeHostText: "A new participant has entered this room allowing the RealTime Audio AI to find a signal pathway that will further reduce latency and optimize audio for this session. Click \"OK\" below to allow this change. Please note, all users will be temporarily disconnected for about 30 seconds.",
        otherMakeHostConnect: "The host has chosen to enable a function to further reduce latency and improve audio for this session. Please note, you will be disconnected for about 30 seconds while this change is enabled.",
        recordingSuccess: "Your current session is being recorded. To change the Host of your session, you will have to stop the current recording. You can find the option to change the host in the Setting popup on the Host tab.",
        streamingSuccess: "Your current session is streaming live. To change the Host of your session, you will have to stop the live stream. You can find the option to change the host in the Setting popup on the Host tab.",
        recordingToPause: "Your current session is being recorded. To change the Auto Manage Host Setting of your session, you will have to stop the current recording.",
        streamingToPause: "Your current session is streaming live. To change the Auto Manage Host Setting of your session, you will have to stop the live stream.",
        recordingToPauseForAudio: "Your current session is being recorded. To change the Audio Mode setting, you will have to stop the current recording.",
        streamingToPauseForAudio: "Your current session is streaming live. To change the Audio Mode setting, you will have to stop the live stream.",
        recordingToPauseForHost: "Your current session is being recorded. To change the Host of your session, you will have to stop the current recording.",
        streamingToPauseForHost: "Your current session is streaming live. To change the Host of your session, you will have to stop the live stream.",
        recordingToPauseForHybrid: "Your current session is being recorded. To change the Hybrid session, you will have to stop the current recording.",
        streamingToPauseForHybrid: "Your current session is streaming live. To change the Hybrid session setting, you will have to stop the live stream.",
        stemWaiting: "Please wait while the recording is processing.",
        enableStemRecording: "Enable individual tracks",
        volumePanning: "Enabling volume panning will automatically change your audio channel mode to Mono-in/Stereo-out.",
        delayPanning: "Selecting delay panning will automatically enable this mode for everyone in the room. It will also change everyone's audio channel mode to Mono-in/Stereo-out.",
        delayPanningParticipantEnable: " has enabled delay panning/3D Sound. Your audio channel mode will be changed to Mono-in/Stereo-out.",
        delayPanningParticipantDisable: " has disabled delay panning/3D Sound.",
        hostToolTip: "This is the recommended host. For lowest latency, consider making this user the host.",
        hostDataWaiting: "Now calculating the average ping time and upload speed for all the users in this room. This will take approximately thirty seconds. If a user enters or leaves, this process will restart. The results will be posted to this tab.",
        makeHostDisconnected: "We are not able to automatically connect to your RealTime Audio device. Please check your connections and then click the RealTime Audio logo in the toolbar to reconnect to your RealTime Audio device.",
        disableFirewall: "We are unable to connect to your RealTime Audio device due to a firewall. Please disable your firewall on your router. Please speak to your IT department if you are not connecting from home. You can learn how to disable your home router firewall by following this <a href=\"https://www.wikihow.com/Disable-Router-Firewall\" target=\"_blank\" >Link</a>",
        spaceIsHalf: "The storage space on your RealTime Audio device is 75% full. Please consider stopping the recording to make more space available.",
        spaceIsFull: "Your space is getting full on your RealTime Audio device. We will auto stop your individual tracks now.",
        monoChannel: "Change Audio channel will automatically enable your volume panning.",
        deviceConnecting: "Please wait while your device connects to the system.",
        // makeHostConnecting: "Please wait while the system re-optimizes for lowest latency.",
        makeHostConnecting: "Please wait while the system re-optimizes for lowest latency.",
        thirdPartyMakeHostConnecting: "Please wait while third party make host functionality is processing.",
        changingBufferDelay: "Your host has chosen to change their frame rate for this session. Please note, you will be temporarily disconnected for about 30 seconds while this function is enabled.",
        uploadSuccess: "File uploaded successfully",
        hostInternetGone: "It seems like your host lost internet connection. So this room will be closed. Try connecting to this room after some time.",
        initializeRecordingHeading: "Recording",
        initializeRecording: "Preparing to record the meeting...",
        hybridSystemConnection: "Please wait while the system is connecting.",
        hybridSystemConnectionTitle: "Connecting",
        hostHangUpProcessing: "Please wait while the system calculates the recommended host.",
        bufferDelayProcessing: "Please wait while the system changes the buffer rate.",
        bufferDelayProcessingLate: "Please hold tight your box is taking time to reconnect.",
        deviceReconnecting: "Please wait while your device is trying to reconnect as your internet connection is interrupted.",
        // userMakeHostProcess: "opted to optimize the session for lowest latency. Please wait while the sytem makes this adjustment.",
        userMakeHostProcess: "opted to optimize the session for lowest latency. Please wait while the system makes this adjustment. Please allow up to 30 seconds for this change to process.",
        micAccessDenied: "You are already connected with a RealTime Audio device that is sending and receiving audio in RealTime. It's ok to unmute your computer mic if you do NOT have a talkback microphone connected to your RTA device. Just make sure to mute it again before you start playing music so others in the jam do not hear your audio signal twice.",
        autoHostCheckboxDisabled: "This is disabled until all calculations are complete.",
        tapAndHold1: " Tap and hold on",
        tapAndHold2: "to get information about the fields.",
        updateJammingStatusSuccess: "Jamming capability updated successfully.",
        updateJammingStatusFail: "Failed to proceed your request, please try later.",
        logoutText: "Do you want to logout?",
        joinRoom: "Do you want switch to this",
        sendEmail: "Please select a user to send email",
        inviteUserError: "Please select at least one user to invite",
        disconnectRTA: "Do you really want to disconnect Realtime Audio device?",
        deleteRecording: "Are you sure you want to delete this recording?",
        startDateValidation: "Please select start date first",
        deleteFile: "Do you really want to remove this file?",
        moderatorStartDateValidation: "Access start date time should be equal or greater then current date time",
        moderatorEndDateValidation: "Access end date time should be equal or greater then access start date time",
        moderatorSelectStartDateValidation: "Please select access start date",
        moderatorSelectEndDateValidation: "Please select access end date",
        moderatorAccessDateValidation: "Please select access date",
        copyCodeTitle: "Copy Link to Embed this Session in your site.",
        makePayment: "Please make payment to access this room",
        enterDetail: "Please enter below details to join this conversation",
        doNotShow: "Don't show this message again.",
        withOutRTAJamming: "Join WITHOUT RealTime Jamming",
        withRTAJamming: "Join WITH RealTime Jamming",
        basicSubscription: "Active BASIC subscription",
        premiumSubscription: "Active PREMIUM subscription",
        RTAPowerDevice: "RealTime Audio powered device",
        jammingModalTitle: "I would like to join this webcam room",
        hostHangupPopupContent: "Your host left the room, Please select the action you want to perform OR the host will automatically change in",
        hostDisconnectContent: "Your host got disconnected, Please select the action you want to perform OR the host will automatically change in",
        serverConnectRehitLoader: "Please wait as it is taking longer than usual to connect to your device.",
        interfaceRemoved: "The system lost connection to your audio interface. Please make sure that your audio interface is plugged into the RealTime device and that it's on. Your system will then reboot and attempt to reconnect you.",
        hangUpConfirmation: "Do you really want to leave this room?",
        ipPortNotAvailable: "Your recommended server is not available anymore, we are redirecting you to another server in the same location which will give you same latency experience.",
        loading: "Loading...",
        unableToProcessAgain: "we are unable to process your request, we are trying again. Please wait",
        unableToProcess: "Unable to process your request, please wait",
        enterBoxId: "Please enter box device ID",
        cantUseInviteLink: "You can't use invite link in mobile app",
        selectValues: "Please select values.",
        recordingPrepared: "Please wait while recording is being prepared.",
        failedStartRecording: "Failed to start recording",
        needLoginToConnect: "You need to login to connect the RealTime Audio device.",
        disconnecting: "Disconnecting",
        disconnectingHybrid: "Disconnecting hybrid session...",
        busyServer: "Busy server"
    },
    internet: {
        internetDisconnectMsg: "Your RealTime Audio device has lost its internet connection. Please make sure your ethernet cable is connected properly. You may need to manually re-connect to your device, reboot your device, or rejoin the session.",
        tempInternetDisconnectMsg: "You got disconnected since your host device lost internet Connection.Try connecting to a different room."
    },
    uploadMedia: {
        toSignInMsg: "Only room owners can upload media. To upload media you must sign in and claim the room to be able to share audio or files.",
        toClaimMsg: "Only room owners can upload media. To upload media you must claim the room to be able to share audio or files.",
        toAskPermissionMsg: "Only room owner can upload media files."
    },
    recording: {
        twoHours: "You've been recording for 2 hours. Do you want to continue or stop the recording? This recording will end in one minute if you do not respond.",
        threeHours: "Its been 3 hrs since you have started the recording, Please confirm if you want to continue or stop recording.",
        fourHours: "Its been 4 hrs since you have started the recording, Please confirm if you want to continue or stop recording.",
        fiveHours: "Its been 5 hrs since you have started the recording and you have reached the limit of recording for one session.",
        autoHostEnabledRecording: "Auto manage host is enable in the conference, Please disable auto manage host to start the recording.",
        autoHostEnabledStreaming: "Auto manage host is enable in the conference, Please disable auto manage host to start the live streaming."

    },
    homeScreen: {
        emptyRoomNameMsg: "Please enter Room Name",
        placeHolderText: "Enter Room Name",
        end: "End",
        rejoin: "Rejoin",
        call: "Call",
        webJam: "WebJam",
        host: "Host",
        alreadyRoomHostedMessage: "You are already hosting room",
        alreadyDeviceHostedMessage: "already in use, please use same room"
    },
    joinRoom: {
        pickDeviceId: "Pick a Device Id",
        or: "OR",
        enterDeviceId: "Enter a Device ID",
        submit: "Submit",
        emptyDeviceIdMsg: "Please enter Device Id",
        noDevicesFound: "No devices found"
    },
    videoScreen: {
        mixer: "Mixer",
        profile: "Profile",
        disconnectMixer: "Disconnect Mixer"
    },
    settingScreen: {
        profileSetting: "Profile Settings",
        audioSettings: "Audio Settings",
        yourProfileName: "Your Profile Name",
        enterProfileName: "Enter Profile Name",
        yourInstrument: "Your Instrument",
        selectInstrument: "Select Instrument",
        selectDevice: "Select Device",
        device: "Device",
        audioChannels: "Audio Channels",
        audioQuality: "Audio Quality",
        selectAc: "Select Channel",
        selectAq: "Select Quality",
        soundCard: "Sound Card",
        jitterBuffer: "Jitter Buffer",
        auto: "Auto",
        enableBuffers: "Enable Small Network Buffers",
        bufferDelay: "Buffer Delay",
        local: "Local",
        server: "Server"
    },
    musicModeWaiting: "Please wait while admin is connecting",
    recRestrictions: {
        webjamModeratorMsg: "Please stop the recording before connecting your RealTime Audio device, You must be connected to your RealTime Audio device before you start the recording.",
        webjamParticipantMsg: "Please ask the Moderator to stop the recording, So that you can connect your RealTime Audio device.",
        hangupModeratorMsg: "Recording is currently active. You should stop your recording before leaving. Do you wish to continue?"
    },
    streamRestrictions: {
        webjamModeratorMsg: "Please stop the live streaming before connecting your RealTime Audio device, You must be connected to your RealTime Audio device before you start the live streaming.",
        webjamParticipantMsg: "Please ask the Moderator to stop the live streaming, So that you can connect your RealTime Audio device.",
        hangupModeratorMsg: " Live Streaming is currently active. You should stop your live stream before leaving. Do you wish to continue?"
    },
    InternetGone: {
        lowBandwidth: "Your internet connection may be too weak for high quality conferencing. Please try moving closer to your router, connecting via ethernet, or (if you are on a mobile device) checking that you are connected via wifi instead of mobile data.",
        conferenceBeforeKickMessage: "The room owner appears to have lost their internet connection. Please standby as we try to reconnect.",
        conferenceBreakKickMessage: "Please note: You may be automatically removed from the room by default if your room owner is not reconnected soon.",
        conferenceKickMessage: "It seems like your room owner was unable to reconnect so this room must be closed. Feel free to try reconnecting to this room after some time."
    },
    confirmMessages: {
        socialRedirect: "Are you sure you want to leave the webcam room?",
        userNotConnectedDevice: "In order to connect your RealTime Audio-powered device, we need to complete a system check from the pre-meeting screen. Click \"OK\" to go to the pre-meeting screen to perform the system check so you can jam in RealTime.",
        userConnectedDevice: "You are connecting to a RealTime Audio device. You will need to return to the pre-meeting screen to complete the system checks.",
        confirmSocialRedirect: "You need to sign in first. Click \"OK\" to go back to the social site to sign in.",
        welcomePageHome: "Do you want to go back to your Webcam Home page?",
        redirectToPrejoin: "It appears you have a RealTime Audio Powered-device. If you wish to use it in this session, you will need to return to the Pre-Meeting screen and perform the system checks to verify that your device is working properly. Do you wish to continue?",
        autoManageHostUserConfirm: "RealTime Audio's AI has detected a way to further reduce latency. Click \"OK\" to allow this change.<br/><br/>Note: Your jam session will be paused for 30 seconds while processing."
    },
    tooltipContent: {
        audioEffectEnable: "Enable audio effects and panning",
        audioEffectDisable: "Disable audio effects and panning",
        micUnmute: "Unmute this user from everyone's mixer (everyone will hear this user)",
        micMute: "Mute this user from everyone's mixer (no one will hear this user)",
        unmuteUser: "Unmute this user (you will hear this user)",
        muteUser: "Mute this user (you will not hear this user)",
        soloOpo: "Switching this back on allows you to hear all users in your mix.",
        solo: "Solo this person (you will only hear this user)",
        unmuteEveryone: "Unmute MY mic (everyone will hear you)",
        muteEveryone: "Mute MY mic (no one will hear you)",
        enterName: "Enter Your Name",
        selectInstrument: "Select Your Instrument",
        audioChannel: "Select input and output (Mono, Mono-in/Stereo-Out, Stereo) Mono is default",
        audioQuality: "Select between Low, Medium and High. High is default.",
        audioInterface: "Select Audio Interface for software version",
        hybridSession: "Enable or disable Hybrid mode",
        lowestLatencyMode: "Lower latency numbers, may add audio anomalies",
        highestLatencyMode: "Better audio, may have a slight bit of latency",
        autoManageHost: "Enable/Disable auto switching to recommended host",
        latencyMetrics: "Click for more information",
        profileLabel: "Change display name",
        videoQuality: "Change video quality",
        fullscreen: "Enable/Disable full screen",
        securityLabel: "Change security options",
        recordingLabel: "Start recording",
        livestreaming: "Start live stream",
        sharedVideo: "Share video",
        shareAudio: "How to share audio",
        selectBackground: "Change your background",
        stats: "Speaker stats",
        settingsLabel: "Settings",
        embedMeeting: "Embed meeting",
        invite: "Invite",
        tileView: "Tile View",
        toggleCamera: "Toggle Camera",
        closedCaptions: "Closed Captions",
        localRecording: "Local Recording",
        linkToSalesForce: "Link to Sale Force",
        muteEveryoneMenu: "Mute everyone",
        muteVideoEveryone: "Disable everyone's camera",
        noiseSuppression: "Noise suppression",
        menuTooltip: "Click here to find recordings and other account settings",
        completeProfile: "Complete your profile",
        profileCompleted: "Profile Completed"
    },
    buttonTitle: {
        yesSmall: "Yes",
        yesCaps: "YES",
        noSmall: "No",
        noCaps: "NO",
        okSmall: "Ok",
        okCaps: "OK",
        cancelSmall: "Cancel",
        cancelCaps: "CANCEL",
        copyCode: "Copy Code",
        closeCaps: "CLOSE",
        closeSmall: "Close",
        clickToPay: "Click to Pay",
        submit: "Submit",
        withRTAJammingCapability: "WITH Real-time jamming capability",
        withOutRtaJammingCapability: "WITHOUT Real-time jamming capability",
        staySmall: "Stay",
        leaveSmall: "Leave",
        backCaps: "BACK",
        backSmall: "Back",
        skip: "Skip",
        next: "Next",
        last: "Last",
        accept: "Accept",
        decline: "Decline",
        rejected: "Rejected",
        accepted: "Accepted",
        connectWithBox: "Connect with box",
        disconnectSmall: "Disconnect",
        unmute: "Unmute"
    },
    typography: { // Popup Titles & Labels & Any other small texts
        myRooms: "My Rooms",
        nxtInvoiceDate: "Next Invoice Date",
        endDate: "End Date",
        subscription: "Subscription",
        trailEndDate: "Trial End Date",
        noRecordFound: "No record found",
        confirmation: "Confirmation",
        alert: "Alert",
        requires: "Requires:",
        inviteByEmail: "Share meeting invitation via Email",
        inviteBySMS: "Share meeting via SMS",
        signInSignUpRequire: "Sign in or Sign up (you will be redirected)",
        noRequirements: "No requirements",
        hostHangupPopupTitle: "Host Hang Up",
        hostDisconnectTitle: "Host Disconnected",
        askEveryTime: "Ask Every Time",
        liveJamming: "Live Jamming",
        noLiveJamming: "No Live Jamming",
        rtaDevice: "Connect RealTime Audio device",
        preMeetingInConferenceTitle: "Checking system status"
    },
    validations: {
        liveStreamEmpty: "Live stream key should not be empty.",
        validEmail: "Please enter a valid email address.",
        emptyEmail: "Email field should not be empty.",
        emptyLink: "Link field should not be empty."
    },
    confirmationDialog: {
        claimBtn: "Claim",
        leaveRoom: "You may have to leave this room. Are you sure you want to leave this room?",
        uploadMediaMsg: "Only room owners can upload media. To upload media you must sign in and claim the room to be able to share audio or files."
    }
};
